var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 183,
    viewBox: "0 0 109 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5123_34265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 109,
    height: 183
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 182.839,
    rx: 16,
    fill: "url(#paint0_linear_5123_34265)",
    fillOpacity: 0.51
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5123_34265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.978 15.7805C139.418 9.51858 130.566 5.03536 121.067 2.65793C111.568 0.280496 101.661 0.0688176 92.0706 2.03834C79.3003 4.63628 67.584 10.9962 58.4083 20.3111C49.2326 29.626 43.0111 41.4761 40.5331 54.3578C38.7235 64.0164 39.0523 73.9582 41.4961 83.4741C43.9399 92.99 48.4385 101.846 54.671 109.409C60.4551 115.983 63.7705 124.389 64.0414 133.168V158.003C64.0414 164.59 66.6394 170.907 71.2639 175.565C75.8884 180.222 82.1605 182.839 88.7005 182.839H121.579C128.119 182.839 134.391 180.222 139.016 175.565C143.64 170.907 146.238 164.59 146.238 158.003V134.741C146.514 125.048 150.05 115.737 156.266 108.333C167.159 94.7629 172.293 77.4117 170.554 60.0503C168.814 42.6889 160.342 26.7203 146.978 15.6149V15.7805ZM129.799 158.003C129.799 160.199 128.933 162.305 127.392 163.857C125.85 165.41 123.759 166.282 121.579 166.282H88.7005C86.5205 166.282 84.4298 165.41 82.8883 163.857C81.3468 162.305 80.4808 160.199 80.4808 158.003V149.725H129.799V158.003ZM143.526 98.0678C135.261 107.941 130.439 120.271 129.799 133.168H113.36V108.333C113.36 106.137 112.494 104.032 110.952 102.479C109.411 100.927 107.32 100.055 105.14 100.055C102.96 100.055 100.869 100.927 99.3277 102.479C97.7862 104.032 96.9202 106.137 96.9202 108.333V133.168H80.4808C80.264 120.487 75.6061 108.29 67.3293 98.7301C61.8685 92.1404 58.1963 84.2381 56.6709 75.7935C55.1455 67.3489 55.8189 58.6503 58.6254 50.5459C61.4319 42.4414 66.2757 35.2078 72.6846 29.5502C79.0935 23.8926 86.8487 20.0041 95.1941 18.264C102.366 16.7767 109.777 16.9166 116.889 18.6735C124.001 20.4304 130.635 23.7602 136.309 28.4212C141.984 33.0822 146.557 38.9573 149.696 45.6201C152.835 52.2829 154.462 59.5661 154.458 66.941C154.519 78.2813 150.653 89.2883 143.526 98.0678Z",
    fill: "url(#paint1_linear_5123_34265)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5123_34265",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 182.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#543EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070417"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5123_34265",
    x1: 56.9635,
    y1: 12.3064,
    x2: 120.957,
    y2: 182.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B0861"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBulb);
export default __webpack_public_path__ + "static/media/big-bulb.4661051317a5d1742ae20e3e87837413.svg";
export { ForwardRef as ReactComponent };